"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../../util/ServiceRegistry"));
var _dcCore = require("dc-core");
var _react = _interopRequireDefault(require("react"));
var _DropinService = require("./DropinService");
var _SecondaryHeaderToolsComponent = _interopRequireDefault(require("../../components/toolsBoard/SecondaryHeaderToolsComponent"));
var _AppConstants = require("../../constants/AppConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class ToolsBoardService {
  constructor() {
    this.initialize = () => {
      this._appstore = _ServiceRegistry.default.getService("AppStore");
      this.loggingService = _ServiceRegistry.default.getService("LoggingService");
      const toolsBoardIntialConfig = this._appstore.toolsBoardInitializationConfig;
      const SecondaryHeaderComponent = () => /*#__PURE__*/_react.default.createElement(_SecondaryHeaderToolsComponent.default, null);
      _dcCore.providers.discovery().then(discovery => {
        discovery.loadDropinClass(toolsBoardIntialConfig.dropinLoadClass).then(async Dropin => {
          const headerTitle = await (0, _DropinService.getHeader)();
          const verbTiles = this.getVerbTiles();
          const config = {
            megaVerb: toolsBoardIntialConfig.megaVerb,
            id: toolsBoardIntialConfig.id,
            header: {
              title: headerTitle,
              hideCloseButton: this._appstore.getConfig().hideCloseButtonInToolsBoard,
              // eslint-disable-next-line no-unused-vars
              secondaryComponent: props => /*#__PURE__*/_react.default.createElement(SecondaryHeaderComponent, null)
            },
            body: props =>
            /*#__PURE__*/
            // eslint-disable-next-line react/react-in-jsx-scope
            _react.default.createElement(Dropin, _extends({}, props, {
              verb: `${toolsBoardIntialConfig.dropinVerb}`,
              context: `${toolsBoardIntialConfig.context}`,
              selectionName: `${toolsBoardIntialConfig.selectionName}`
            })),
            verbTilesTitle: verbTiles.length > 0 ? this._appstore.intl.formatMessage({
              id: "verbTiles.header.title"
            }) : "",
            verbTiles,
            entryOpts: this._appstore.executeActionOpts
          };
          const callbackConfig = _objectSpread(_objectSpread({}, config), {}, {
            exitCallback: _DropinService.exitCallback
          });
          this._appstore.toolsBoardConfig = callbackConfig;
          this._appstore.toolsBoardsConfigPromise.resolve();
        }).catch(error => {
          // eslint-disable-next-line max-len
          this.loggingService.error("ToolsBoard", "Error in loading Toolsboard edit component dropin", error);
        });
      });
    };
  }
  getVerbTiles() {
    const verbTiles = [];
    const {
      enableCropPages,
      enableNumberPages
    } = this._appstore.getActionConfig("preview");
    if (enableCropPages) {
      verbTiles.push({
        verbId: _AppConstants.VERB_CROP_PAGES_VIEWER
      });
    }
    if (enableNumberPages) {
      verbTiles.push({
        verbId: _AppConstants.VERB_NUMBER_PAGES_VIEWER
      });
    }
    return verbTiles;
  }

  // eslint-disable-next-line consistent-return
  getToolsBoardConfig(type) {
    switch (type) {
      case "group-edit":
        {
          return this.getEditToolsBoardConfig();
        }
      default:
        break;
    }
  }
  getEditToolsBoardConfig() {
    return this._appstore.toolsBoardsConfigPromise.promise.then(() => this._appstore.toolsBoardConfig);
  }
  openToolsBoard() {
    return this._appstore.toolsBoardsConfigPromise.promise.then(() => _dcCore.providers["tools-board-provider"]()).then(toolsBoardProvider => toolsBoardProvider.setConfig(this._appstore.toolsBoardConfig));
  }
  closeToolsBoard() {
    _dcCore.providers["tools-board-provider"]().then(toolsBoardProvider => {
      const currentConfig = toolsBoardProvider.getConfig();
      if (currentConfig) {
        return toolsBoardProvider.reset();
      }
      this._appstore.exitCallbackPromise.resolve(true);
      return Promise.resolve();
    });
  }
}
exports.default = ToolsBoardService;